import React, { createContext, type ReactNode, useContext } from 'react';

import type { SearchUseCaseId } from '@atlassian/search-common/search-use-case-id';

const SearchUseCaseIdContext = createContext<SearchUseCaseId | undefined>(undefined);

export const SearchUseCaseIdProvider = ({
	children,
	value,
}: {
	children: ReactNode;
	value?: SearchUseCaseId;
}): React.JSX.Element => (
	<SearchUseCaseIdContext.Provider value={value}>{children}</SearchUseCaseIdContext.Provider>
);

/**
 * Returns the business identity selected by the owning Search surface.
 *
 * This is construction context, not mutable search state. A missing provider is a programming
 * error because Search Platform requests must not infer or silently default their identity.
 */
export const useSearchUseCaseId = (): SearchUseCaseId => {
	const useCaseId = useContext(SearchUseCaseIdContext);

	if (useCaseId === undefined) {
		throw new Error('SearchUseCaseIdProvider is required');
	}

	return useCaseId;
};
